var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"room-types","title":"Room Type","schema":[
    {
      component: 'FInput',
      key: 'name',
      label: 'Name'
    },
    {
      component: 'FInput',
      key: 'sleeps',
      label: 'Sleeps',
      domProps: {
        type: 'number',
        min: 0,
        max: 10,
        step: 1
      }
    }
  ]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }